/*
 * @Author: bbqin
 * @Date: 2021-07-09 11:10:14
 * @LastEditTime: 2023-01-16 13:58:35
 * @LastEditors: bbqin
 * @Description: 功能出口
 * @FilePath: \Platform_Front\src\platform\components\Transfer\index.js
 * 这锅我不背
 */

import React, { Component } from 'react';

import ListToListTransfer from './listToList';
import TreeToListTransfer from './treeToList';
import ListToList from './ListToListTransfer/index';
import TreeToList from './TreeToListTransfer/index';
import TreeToTreeTransfer from './TreetoTreeTransfer/treeToTree';

export class OldTransfer extends Component {
    render() {
        let { treeType, ...others } = this.props;
        return treeType ? <TreeToList {...others} /> : <ListToList {...others} />;
    }
}

export { ListToListTransfer, TreeToListTransfer,TreeToTreeTransfer };
export default class Transfer extends Component {
    render() {
        let { treeType, ...others } = this.props;
        return treeType ? <TreeToListTransfer {...others} /> : <ListToListTransfer {...others} />;
    }
}
